import { lazy } from 'react';

const Dashboard = {
  Helmet: lazy(() => import('./components/Helmet')),
  Providers: lazy(() => import('./components/Providers')),
  Dashboard: lazy(() => import('./containers/Dashboard')),
  Documents: lazy(() => import('./containers/Documents')),
};

export default Dashboard;
